import useSWR from 'swr';
import api from '@/service/api';

/**
 * Get pricing plans from backend
 */
export function usePricingPlans() {
  const { data, error, isLoading } = useSWR(
    '/billing/pricing',
    async () => {
      const response = await api.billing.getPricingPlans();
      return response.data;
    },
    {
      dedupingInterval: 60000, // Pricing is static — dedup for 60s
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  return {
    plans: data?.plans || [],
    loading: isLoading,
    error,
  };
}
